import appConfig from "./appConfig";

interface MessageFormat {
    type: string;
    userId?: string;
    user?: User;
    email?: string;
}

const Message = {
    closeWindow(): void {
        this._postMessageToParent({ type: "REG-HIDE-POPUP" });
    },

    userCloseWindow(): void {
        this._postMessageToParent({ type: "REG-USER-HIDE-POPUP" });
    },

    userSignedIn(user: User): void {
        this._postMessageToBloomberg({ type: "REG-USER-SIGNED-IN", userId: user.id, user });
    },

    userRegistered(email: string): void {
        this._postMessageToBloomberg({ type: "REG-USER-REGISTERED", email });
    },

    _postMessageToParent(message: MessageFormat): void {
        if (window.parent !== window) {
            window.parent.postMessage(message, "*");
        }

        if (window.opener && window.opener !== window) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            window.opener.postMessage(message, "*");
        }
    },

    _postMessageToBloomberg(message: MessageFormat): void {
        if (window.parent !== window) {
            window.parent.postMessage(message, appConfig().bloombergSiteUrl);
        }

        if (window.opener && window.opener !== window) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
            window.opener.postMessage(message, appConfig().bloombergSiteUrl);
        }
    }
};

export default Message;
